export const ACTION_TYPES = {
  UPDATE_FORM_STEP: 'UPDATE_FORM_STEP',
  UPDATE_EMPLOYER_INFO: 'UPDATE_EMPLOYER_INFO',
  UPDATE_JOB_INFO: 'UPDATE_JOB_INFO',
  UPDATE_ERROR: 'UPDATE_ERROR_BY_KEY',
  SEND_FORM_RESPONSE: 'SEND_FORM_RESPONSE',
  UPDATE_NUM_OF_JOBS_POSTED: 'UPDATE_NUM_OF_JOBS_POSTED',
  UPDATE_NUM_OF_JOBS_POSTED_RECRUITER: 'UPDATE_NUM_OF_JOBS_POSTED_RECRUITER',
  UPDATE_NUM_OF_JOBS_POSTED_SUBSCRIPTION: 'UPDATE_NUM_OF_JOBS_POSTED_SUBSCRIPTION',
  CLEAR_JOB_INFO: 'CLEAR_JOB_INFO',
};

const initialState = {
  postJobStep: 1,
  jobsPosted: 0,
  jobsPostedRecruiter: 0,
  jobsPostedSubscription: 0,

  // answer given by use and error
  errors: {},
  employerInfo: {},
  jobToPost: {},
};

const PostJob = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_FORM_STEP:
      // surveyStep && survey_step
      return {
        ...state,
        postJobStep: action.payload,
      };
    case ACTION_TYPES.UPDATE_EMPLOYER_INFO:
      return {
        ...state,
        employerInfo: {
          ...state.employerInfo,
          ...action.payload,
        },
      };
    case ACTION_TYPES.UPDATE_JOB_INFO:
      return {
        ...state,
        jobToPost: {
          ...state.jobToPost,
          ...action.payload,
        },
      };
    case ACTION_TYPES.UPDATE_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          ...action.payload,
        },
      };
    case ACTION_TYPES.UPDATE_NUM_OF_JOBS_POSTED:
      return {
        ...state,
        jobsPosted: action.payload,
      };
    case ACTION_TYPES.UPDATE_NUM_OF_JOBS_POSTED_RECRUITER:
      return {
        ...state,
        jobsPostedRecruiter: action.payload,
      };
    case ACTION_TYPES.UPDATE_NUM_OF_JOBS_POSTED_SUBSCRIPTION:
      return {
        ...state,
        jobsPostedSubscription: action.payload,
      };
    case ACTION_TYPES.CLEAR_JOB_INFO:
      return {
        ...state,
        jobToPost: initialState.jobToPost,
      };
    default:
      return state;
  }
};
export default PostJob;
